<template>
  <admin-page-frame>
    <div class="schools-admin-page__dash-tip">
      <i class="el-icon-info" />
      线下收费 · 多机构 SaaS · 班课/1v1 · 请假不扣课
    </div>

    <div v-loading="loading" class="schools-admin-page__dash-stats">
      <div
        v-for="item in statCards"
        :key="item.key"
        class="schools-admin-page__dash-stat"
        :class="{ 'schools-admin-page__dash-stat--link': !!item.path }"
        @click="goPage(item.path)"
      >
        <div class="schools-admin-page__dash-stat__icon" :style="{ background: item.color }">
          <i :class="item.icon" />
        </div>
        <div class="schools-admin-page__dash-stat__body">
          <div class="schools-admin-page__dash-stat__label">{{ item.label }}</div>
          <div class="schools-admin-page__dash-stat__value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <el-row :gutter="12">
      <el-col :span="8">
        <el-card shadow="never" class="schools-admin-page__dash-card" header="班型分布">
          <schools-dash-pie :items="classTypePie" />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never" class="schools-admin-page__dash-card" header="今日课次状态">
          <schools-dash-pie :items="sessionStatusPie" />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never" class="schools-admin-page__dash-card" header="近7日课次趋势">
          <schools-dash-bar :items="weekSessionBar" />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :span="8">
        <el-card shadow="never" class="schools-admin-page__dash-card" header="今日待办">
          <ul v-if="realTodos.length" class="schools-admin-page__dash-todo">
            <li v-for="t in realTodos" :key="t">{{ t }}</li>
          </ul>
          <div v-else class="schools-dash-empty">暂无待办</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never" class="schools-admin-page__dash-card" header="快捷入口">
          <div class="schools-admin-page__dash-links">
            <el-button
              v-for="link in quickLinks"
              :key="link.path"
              size="mini"
              :icon="link.icon"
              @click="goPage(link.path)"
            >{{ link.title }}</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never" class="schools-admin-page__dash-card" header="今日课表摘要">
          <el-table
            class="schools-admin-page__mini-table"
            :data="todaySessions"
            size="small"
            :border="false"
            empty-text="今日无课次"
            style="width: 100%;"
          >
            <el-table-column prop="startTime" label="时间" width="70" />
            <el-table-column prop="className" label="班级" min-width="80" show-overflow-tooltip />
            <el-table-column prop="statusText" label="状态" width="70" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </admin-page-frame>
</template>

<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import SchoolsDashPie from './components/SchoolsDashPie.vue'
import SchoolsDashBar from './components/SchoolsDashBar.vue'
import { fetchSchoolsDashboardToday } from '@/api/h5-admin-schools'
import './schools-admin.less'

export default {
  name: 'SchoolsDashboard',
  components: { AdminPageFrame, SchoolsDashPie, SchoolsDashBar },
  data() {
    return {
      loading: false,
      statCards: [],
      todos: [],
      classTypePie: [],
      sessionStatusPie: [],
      weekSessionBar: [],
      todaySessions: [],
      quickLinks: [
        { title: '排课中心', path: '/admin/schools/schedule', icon: 'el-icon-date' },
        { title: '考勤课消', path: '/admin/schools/attendance', icon: 'el-icon-circle-check' },
        { title: '报名订单', path: '/admin/schools/enroll', icon: 'el-icon-s-order' },
        { title: '请假管理', path: '/admin/schools/leave', icon: 'el-icon-document-remove' },
        { title: '学员档案', path: '/admin/schools/student', icon: 'el-icon-user' },
        { title: '班级管理', path: '/admin/schools/class', icon: 'el-icon-s-grid' }
      ]
    }
  },
  computed: {
    realTodos() {
      return (this.todos || []).filter(t => t && t.indexOf('暂无') === -1)
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    goPage(path) {
      if (path) this.$router.push(path)
    },
    loadData() {
      this.loading = true
      fetchSchoolsDashboardToday()
        .then(res => {
          const s = (res && res.stats) || {}
          this.statCards = [
            { key: 'session', label: '今日课次', value: n(s.todaySessionCount), icon: 'el-icon-date', color: '#409EFF', path: '/admin/schools/schedule' },
            { key: 'attendance', label: '待点名', value: n(s.pendingAttendanceCount), icon: 'el-icon-circle-check', color: '#E6A23C', path: '/admin/schools/attendance' },
            { key: 'leave', label: '待审批请假', value: n(s.pendingLeaveCount), icon: 'el-icon-document-remove', color: '#F56C6C', path: '/admin/schools/leave' },
            { key: 'payment', label: '待到校缴费', value: n(s.pendingPaymentCount), icon: 'el-icon-wallet', color: '#909399', path: '/admin/schools/enroll' },
            { key: 'students', label: '在读学员', value: n(s.totalStudents), icon: 'el-icon-user', color: '#67C23A', path: '/admin/schools/student' },
            { key: 'classes', label: '在办班级', value: n(s.activeClasses), icon: 'el-icon-s-grid', color: '#409EFF', path: '/admin/schools/class' },
            { key: 'teachers', label: '在职教师', value: n(s.totalTeachers), icon: 'el-icon-s-custom', color: '#9B59B6', path: '/admin/schools/teacher' },
            { key: 'courses', label: '上架课程', value: n(s.totalCourses), icon: 'el-icon-reading', color: '#13C2C2', path: '/admin/schools/course' }
          ]
          this.todos = (res && res.todos) || []
          this.classTypePie = (res && res.classTypePie) || defaultClassPie()
          this.sessionStatusPie = (res && res.sessionStatusPie) || defaultSessionPie()
          this.weekSessionBar = (res && res.weekSessionBar) || []
          this.todaySessions = mapSessions((res && res.todaySessions) || [])
        })
        .finally(() => { this.loading = false })
    }
  }
}

function n(v) {
  return v != null ? v : 0
}

function defaultClassPie() {
  return [
    { name: '班课', value: 0, color: '#409EFF' },
    { name: '一对一', value: 0, color: '#67C23A' }
  ]
}

function defaultSessionPie() {
  return [
    { name: '待上课', value: 0, color: '#409EFF' },
    { name: '已结束', value: 0, color: '#67C23A' },
    { name: '已停课', value: 0, color: '#909399' }
  ]
}

function mapSessions(list) {
  const statusMap = { scheduled: '待上课', finished: '已结束', cancelled: '已停课' }
  return list.slice(0, 6).map(row => ({
    startTime: formatTime(row.startTime),
    className: row.className || ('班级' + (row.classId || '')),
    statusText: statusMap[row.status] || row.status || '-'
  }))
}

function formatTime(t) {
  if (!t) return '-'
  const s = String(t)
  return s.length >= 5 ? s.substring(0, 5) : s
}
</script>

<style scoped lang="less">
.schools-dash-empty {
  padding: 8px 0;
  text-align: center;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}
</style>
